export function registerEpisodeSelectionConsumerState(consumers, consumerId) {
    return Array.from(new Set([...(consumers || []), consumerId]));
}

export function beginEpisodeSelectionTransaction(state, target) {
    const revision = Number(state?.revision || 0) + 1;
    const pendingConsumerIds = Array.from(new Set(state?.registeredConsumerIds || []));

    return {
        revision,
        busy: pendingConsumerIds.length > 0
            ? { revision, target, pendingConsumerIds }
            : null,
    };
}

export function acknowledgeEpisodeSelectionTransaction(busy, revision, consumerId) {
    if (!busy || busy.revision !== revision || !busy.pendingConsumerIds.includes(consumerId)) {
        return busy;
    }

    const pendingConsumerIds = busy.pendingConsumerIds.filter((id) => id !== consumerId);
    return pendingConsumerIds.length > 0 ? { ...busy, pendingConsumerIds } : null;
}

export function unregisterEpisodeSelectionConsumerState(consumers, busy, consumerId) {
    const registeredConsumerIds = (consumers || []).filter((id) => id !== consumerId);
    const nextBusy = busy
        ? acknowledgeEpisodeSelectionTransaction(busy, busy.revision, consumerId)
        : null;

    return { registeredConsumerIds, busy: nextBusy };
}
